module.exports = __webpack_public_path__ + "static/media/CLicon03.e6fb6fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/CLicon03.png
// module id = 1706
// module chunks = 0 1